import React from 'react';
import {
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  UncontrolledTooltip,
} from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter} from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { DatePicker, PaginationTotal } from '../../../commons/controls';
import _ from 'lodash';
import Services from '../services';
import Lib from '../../../commons/lib';
import HelyiArForm from './HelyiArForm';
import RFField from '../../../components/Form/RFField';
import RFForm from '../../../components/Form/RFForm';
import SelectField from '../../../components/Form/SelectField';

const STYLE_LABEL_ROW = {marginTop: '15px', marginBottom: '15px'};
const STYLE_CHECKBOX = {margin: 0, position: 'absolute', top: '50%', msTransform: 'translateY(-50%)', transform: 'translateY(-50%)'}
const KartyaTipusForm = props => {
  const {
    modositas,
    formKod,
    formNev,
    formAzonositoGen,
    formPrefix,
    formSablon,
    formKiegeszito,
    formDarabszam,
    formPartnercsoport,
    formCsoport,
    formSzuletesnap,
    formTelefonszam,
    formEmail,
    formErvenyessegKezdete,
    formErvenyessegVege,
    formErvenyessegVegeTipus,
    formVegeTol,
    formCsere,
    formErvenyesitheto,
    formFizetesimodkotelezo,
    formHelyiArak,
    helyszinAr,
    handleInputChange,
    handleSelectInputChange,
    handleDateInputChange,
  } = props;

  const loadCsoportParamOptions = (input, callback) => {
    Services.loadCsoportParamOptions((err, res) => {
      if (!err) {
        let options = [];
        res[0].forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const loadTulajdonosOptions = (input, callback) => {
    Services.loadTulajdonosOptions((err, res) => {
      if (!err) {
        let options = [];
        res[0].forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const loadDatumOptions = (input, callback) => {
    Services.loadDatumOptions((err, res) => {
      if (!err) {
        let options = [];
        res[0].forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const loadVegeOptions = (input, callback) => {
    Services.loadVegeOptions((err, res) => {
      if (!err) {
        let options = [];
        res[0].forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const loadVegeTipusOptions = (input, callback) => {
    Services.loadVegeTipusOptions((err, res) => {
      if (!err) {
        let options = [];
        res[0].forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const loadPartnercsoportOptions = (input, callback) => {
    Services.listPartnercsoportAktiv((err, res) => {
      if (!err) {
        let options = [];
        res[0].filter( k => k.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const loadSablonOptions = (input, callback) => {
    let options = [];
    [{id: 0, nev: 'Alapértelmezett sablon'}].forEach((item) => {
      options.push(item);
    });
    callback(options);
  }

  const tableIconFormatter = (cell, row) => {
    return (
      <div>
        <React.Fragment> 
          <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => helyszinAr.handleEditHelyiArClick(row)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
          <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'modositas'} delay={50}>
            {'Módosítás'}
          </UncontrolledTooltip>

          <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'delete'} onClick={() => helyszinAr.handleDeleteHelyiArClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
          <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'delete'} delay={50}>
            {'Törlés'}
          </UncontrolledTooltip>
        </React.Fragment>
      </div>
    );
  }

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange
  }) => (
    <div className="btn-group" role="group">
      {
        options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={ option.text }
              type="button"
              onClick={ () => onSizePerPageChange(option.page) }
              className={ `btn ${isSelect ? 'btn-primary' : 'btn-secondary'}` }
            >
              { option.text }
            </button>
          );
        })
      }
    </div>
  );

  const formatPrice = (ar, penznem) => {
    return ar || ar === 0 ? ar + (penznem && penznem.jel ? " " + penznem.jel : "") : "";
  }

  const renderHelyiArTable = () => {
    const options = {
      sizePerPage: 5,
      showTotal: true,
      sizePerPageRenderer: sizePerPageRenderer,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ],
    };

    const columns = [
      {
        dataField: 'helyszin.nev',
        text: 'Helyszín',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true,
        formatter: cell => cell ? cell : "ALAPÉRTELMEZETT"
      },
      {
        dataField: 'alapAr',
        text: 'Alap ár',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true,
        headerStyle: (colum, colIndex) => ({ width: '100px'}),
        formatter: (cell, row) => formatPrice(cell, row.penznem)
      },
      {
        dataField: 'csereAr',
        text: 'Csere ár',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true,
        headerStyle: (colum, colIndex) => ({ width: '100px'}),
        formatter: (cell, row) => formatPrice(cell, row.penznem)
      },
      {
        dataField: 'ervenyesseg',
        text: 'Érvényesség',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true,
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        headerStyle: (colum, colIndex) => ({ width: '150px'}),
        formatter: tableIconFormatter
      }
    ];

    return (
        <div className="animated fadeIn">
          <BootstrapTable
            bootstrap4
            keyField="id"
            data={formHelyiArak}
            columns={columns}
            filter={filterFactory()}
            pagination={paginationFactory(Lib.bootstraptableProps)}
            noDataIndication="Nincs megjelenítendő adat!"
          />
        </div>
    );
  }

  const renderHelyiArModal = () => {
    return (
      <React.Fragment>
          <Modal isOpen={helyszinAr.modalHelyiArForm} toggle={helyszinAr.toggleHelyiArForm} backdrop="static">
            <RFForm
              modal
              title="Helyi árak karbantartása"
              footer={
                <>
                  <Button
                    type="button"
                    className="btn-cursor-pointer"
                    color="primary"
                    onClick={helyszinAr.handleAddHelyiAr}
                  >
                    {'Mentés'}
                  </Button>
                  <Button type="button" color="secondary" onClick={helyszinAr.toggleHelyiArForm}>Mégsem</Button>
                </>
              }
            >
              <HelyiArForm 
                helyszinAr={helyszinAr}
                handleInputChange={handleInputChange}
                handleDateInputChange={handleDateInputChange}
                handleSelectInputChange={handleSelectInputChange}
              />
            </RFForm>
          </Modal>
      </React.Fragment>
    );
  }

  const renderHelyiAr = () => {
    return (
      <React.Fragment>
        <div className="row" style={STYLE_LABEL_ROW}>
          <div className="col-md-2">
            <Button type="button" color="primary" style={{ width: '100%' }} onClick={helyszinAr.handleNewHelyiAr}>
              {'Új hozzáadása'}
            </Button>
          </div>
        </div>
        <div className="row" style={STYLE_LABEL_ROW}>
          <div className="col-md-12">
            {renderHelyiArTable()}
          </div>
        </div>
        {renderHelyiArModal()}
      </React.Fragment>
    );
  }

  const renderForm = () => {
    const vegeTolAvailable = !!formErvenyessegVege && formErvenyessegVege.name === "KIALLITASTOL";
    const isPartnerSelected = formCsoport && formCsoport.name.includes("PARTNER");

    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-6">
            <RFField
              label="Azonosító: "
              disabled={modositas}
              name={"formKod"}
              onChange={handleInputChange}
              value={formKod}
              required
            />
          </div>
          <div className="col-md-6">
            <RFField
              label="Név: "
              name={"formNev"}
              id={"formNev"}
              onChange={handleInputChange}
              value={formNev}
              required
            />
          </div>
        </div>
        <div className="row" style={STYLE_LABEL_ROW}>
          <div className="col-md-6">
            <h5>Azonosító</h5>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <RFField
              label="Prefix: "
              name={"formPrefix"}
              onChange={handleInputChange}
              value={formPrefix}
              required
            />
          </div>
          <div className="col-md-4">
            <SelectField
              variant='async'
              label='Sablon:'
              name="formSablon"
              id="formSablon"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => handleSelectInputChange(v, 'formSablon')}
              loadOptions={_.debounce(loadSablonOptions, 1000)}
              getOptionLabel={option => option.nev}
              getOptionValue={option => option.id}
              value={formSablon}
              cache={false}
              isLoading={false}
              isClearable
              defaultOptions
              required
            />
          </div>
          <div className="col-md-auto" style={{ marginTop: 35 }}>
            <RFField
              label="Generálás"
              // check
              // style={STYLE_CHECKBOX}
              type="checkbox"
              name="formAzonositoGen"
              onChange={handleInputChange}
              value={formAzonositoGen}
            />
          </div>
          <div className='w-100' />
          <div className="col-md-8">
            <RFField
              label="Sablon kiegészítő szöveg: "
              name="formKiegeszito"
              onChange={handleInputChange}
              value={formKiegeszito}
              maxLength={50}
            />
          </div>
        </div>
        <div className="row" style={STYLE_LABEL_ROW}>
          <div className="col-md-6">
            <h5>Darabszám</h5>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <RFField
              label="Maximális darabszám: "
              name={"formDarabszam"}
              onChange={handleInputChange}
              value={formDarabszam}
            />
          </div>
        </div>
        <div className="row" style={STYLE_LABEL_ROW}>
          <div className="col-md-6">
            <h5>Tulajdonos</h5>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4" style={{paddingRight: '2px'}}>
            {/* <Label for="formCsoport">Csoport kiválasztás:</Label> */}
            <SelectField
              variant='async'
              name="formCsoport"
              id="formCsoport"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => handleSelectInputChange(v, 'formCsoport')}
              loadOptions={_.debounce(loadCsoportParamOptions, 1000)}
              getOptionLabel={option => option.caption}
              getOptionValue={option => option.name}
              value={formCsoport}
              cache={false}
              isLoading={false}
              isClearable
              defaultOptions
              required
            />
          </div>
        </div>
        {isPartnerSelected && (
        <React.Fragment>
          <div className="row" style={STYLE_LABEL_ROW}>
            <div className="col-md-6">
              <h5>Partner rögzítés</h5>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4" style={{paddingRight: '2px'}}>
              <SelectField
                variant='async'
                label='Telefonszám:'
                name="formTelefonszam"
                id="formTelefonszam"
                placeholder="Kezdj el gépelni..."
                noOptionsMessage={() => 'Nincs keresési eredmény'}
                onChange={v => handleSelectInputChange(v, 'formTelefonszam')}
                loadOptions={_.debounce(loadTulajdonosOptions, 1000)}
                getOptionLabel={option => option.caption}
                getOptionValue={option => option.name}
                value={formTelefonszam}
                cache={false}
                isLoading={false}
                isClearable
                defaultOptions
                required
              />
            </div>
            <div className="col-md-4" style={{paddingRight: '2px'}}>
              <SelectField
                variant='async'
                label='Email:'
                name="formEmail"
                id="formEmail"
                placeholder="Kezdj el gépelni..."
                noOptionsMessage={() => 'Nincs keresési eredmény'}
                onChange={v => handleSelectInputChange(v, 'formEmail')}
                loadOptions={_.debounce(loadTulajdonosOptions, 1000)}
                getOptionLabel={option => option.caption}
                getOptionValue={option => option.name}
                value={formEmail}
                cache={false}
                isLoading={false}
                isClearable
                defaultOptions
                required
              />
            </div>
            <div className="col-md-4" style={{paddingRight: '2px'}}>
              <SelectField
                variant='async'
                label='Születésnap:'
                name="formKartyaTipus"
                id="formKartyaTipus"
                placeholder="Kezdj el gépelni..."
                noOptionsMessage={() => 'Nincs keresési eredmény'}
                onChange={v => handleSelectInputChange(v, 'formSzuletesnap')}
                loadOptions={_.debounce(loadTulajdonosOptions, 1000)}
                getOptionLabel={option => option.caption}
                getOptionValue={option => option.name}
                value={formSzuletesnap}
                cache={false}
                isLoading={false}
                isClearable
                defaultOptions
                required
              />
            </div>
          </div>
          <div className="row" style={STYLE_LABEL_ROW}>
            <div className="col-md-2" style={{paddingTop: '8px'}}>
              <h5>Partnercsoport:</h5>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4" style={{paddingRight: '2px'}}>
              <SelectField
                variant='async'
                name="formPartnercsoport"
                id="formPartnercsoport"
                placeholder="Kezdj el gépelni..."
                noOptionsMessage={() => 'Nincs keresési eredmény'}
                onChange={v => handleSelectInputChange(v, 'formPartnercsoport')}
                loadOptions={_.debounce(loadPartnercsoportOptions, 1000)}
                defaultOptions
                getOptionLabel={option => option.nev}
                getOptionValue={option => option.id}
                value={formPartnercsoport}
                isClearable
              />
            </div>
          </div>
        </React.Fragment>
        )}
        <div className="row" style={STYLE_LABEL_ROW}>
          <div className="col-md-6">
            <h5>Érvényesség</h5>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4" style={{paddingRight: '2px'}}>
            <SelectField
              variant='async'
              label='Kezdete:'
              name="formErvenyessegKezdete"
              id="formErvenyessegKezdete"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => handleSelectInputChange(v, 'formErvenyessegKezdete')}
              loadOptions={_.debounce(loadDatumOptions, 1000)}
              getOptionLabel={option => option.caption}
              getOptionValue={option => option.name}
              value={formErvenyessegKezdete}
              cache={false}
              isLoading={false}
              isClearable
              defaultOptions
              required
            />
          </div>
          <div className="col-md-4" style={{paddingRight: '2px'}}>
            <SelectField
              variant='async'
              label='Vége:'
              name="formErvenyessegVege"
              id="formErvenyessegVege"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => handleSelectInputChange(v, 'formErvenyessegVege')}
              loadOptions={_.debounce(loadVegeOptions, 1000)}
              getOptionLabel={option => option.caption}
              getOptionValue={option => option.name}
              value={formErvenyessegVege}
              cache={false}
              isLoading={false}
              isClearable
              defaultOptions
              required
            />
          </div>
          <div className="col-md-4" style={{paddingRight: '2px'}}>
            <SelectField
              variant='async'
              label='Vége típusa:'
              name="formErvenyessegVegeTipus"
              id="formErvenyessegVegeTipus"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => handleSelectInputChange(v, 'formErvenyessegVegeTipus')}
              loadOptions={_.debounce(loadVegeTipusOptions, 1000)}
              getOptionLabel={option => option.caption}
              getOptionValue={option => option.name}
              value={formErvenyessegVegeTipus}
              cache={false}
              isLoading={false}
              isClearable
              defaultOptions
              required
            />
          </div>  
          {vegeTolAvailable && 
            <div className="col-md-2">
              <RFField
                onChange={handleInputChange}
                label="Nap: "
                name={"formVegeTol"}
                value={formVegeTol}
                numberOnlyWhole
                required
              />
            </div>
          }
        </div>
        <div className="row" style={STYLE_LABEL_ROW}>
          <div className="col-md-3">
            <h5>Egyéb</h5>
          </div>
          <div className="col-md">
            <RFField
              label="Csere lehetséges"
              // check
              // style={STYLE_CHECKBOX}
              onChange={handleInputChange}
              type="checkbox"
              name="formCsere"
              checked={formCsere}
            />
          </div>
          <div className="col-md">
            <RFField
              label="Újra érvényesíthető"
              onChange={handleInputChange}
              // check
              // style={STYLE_CHECKBOX}>
              type="checkbox"
              name="formErvenyesitheto"
              value={formErvenyesitheto}
            />
          </div>
          <div className="col-md">
            <RFField
              label="Fizetési mód kötelező"
              onChange={handleInputChange}
              // check
              // style={STYLE_CHECKBOX}>
              type="checkbox"
              name="formFizetesimodkotelezo"
              value={formFizetesimodkotelezo}
            />
          </div>
        </div>
        <div className="row">
        </div>
        <div className="row justify-content-md-center" style={STYLE_LABEL_ROW}>
          <div className="col-md-4">
            <Button type="button" color="primary" style={{ width: '100%' }} onClick={helyszinAr.toggleHelyiAr}>
              {'Árak    '}
              {helyszinAr.showHelyiAr ? 
                <i className="fa fa-sort-up" aria-hidden="true"></i>
              :
                <i className="fa fa-sort-down" aria-hidden="true"></i>
              }
            </Button>
          </div>
        </div>
        {helyszinAr && helyszinAr.showHelyiAr && renderHelyiAr()}
      </React.Fragment>
    );
  }
  
  return (
    <div className="row">
      <div className="col-md-12">
        {renderForm()}
      </div>
    </div>
  );
}

export default KartyaTipusForm;